/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Task = {
    properties: {
        id: {
            type: 'string',
            isRequired: true,
        },
        room: {
            type: 'string',
            isRequired: true,
        },
    },
} as const;
